/**
 * Full-screen frames (FullScreenFlowShell, DocumentPreviewFrame) cover the role
 * shell, so a centered pop-up opened over one must sit between THE FRAME's
 * header and bottom bar, not the shell's. Frames mark their chrome with these
 * attributes; `useModalTouchReserves` measures the topmost visible ones.
 */
export const OVERLAY_HEADER_ATTR = 'data-cvx-overlay-header';
export const OVERLAY_BAR_ATTR = 'data-cvx-overlay-bar';
export const OVERLAY_FRAME_SELECTOR = '[data-cvx-overlay-frame]';
export const OVERLAY_HEADER_SELECTOR = `[${OVERLAY_HEADER_ATTR}]`;
export const OVERLAY_BAR_SELECTOR = `[${OVERLAY_BAR_ATTR}]`;
/** Dispatched on `window` when a frame mounts or unmounts so the reserves re-measure. */
export const OVERLAY_CHROME_EVENT = 'cvx:overlay-chrome-change';

export function emitOverlayChromeChange() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(OVERLAY_CHROME_EVENT));
}

/** The LAST element (document order = topmost frame) whose rect has height. */
export function lastVisible(selector) {
  if (typeof document === 'undefined') return null;
  const nodes = document.querySelectorAll(selector);
  for (let i = nodes.length - 1; i >= 0; i -= 1) {
    if (nodes[i].getBoundingClientRect().height > 0) return nodes[i];
  }
  return null;
}
